var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.606,7.703c2.212,3.828,4.989,7.127,8.15,10.192.181.176,1.067.769,1.017,1.005l-10.026,8.323c-2.391-4.234-5.459-7.964-9.17-11.101l10.028-8.419Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.42,19.843c1.198,1.097,2.195,2.397,3.148,3.708l-.083.302-15.742,13.545c-2.89,2.032-6.196-1.43-4.059-4.167l16.737-13.389Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.862,45.57h-27.463c-.317-1.757-.223-3.908,1.818-4.458l23.742-.022c2.107.506,2.232,2.686,1.903,4.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.572,18.343c.257-.077.565-.024.775.145.335.271,1.285,1.509,1.612,1.928.362.463,1.057,1.046.588,1.656l-12.787,10.501-.561-.149-2.302-2.74c-.19-.331-.175-.592.043-.906l12.631-10.435Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.932,16.46c-.736-.627-1.491-2.039-2.232-2.756l.06-.789L24.198,2.611c.258-.192.635-.258.913-.064l2.287,2.754c.149.254.203.596.019.851l-12.352,10.282c-.406.362-.716.38-1.132.026Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.322,40.42h-20.382v-1.985c0-.591,1.038-1.653,1.639-1.794l16.859-.077c.696.088,1.884,1.199,1.884,1.871v1.985Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegal);
export default __webpack_public_path__ + "static/media/icon-legal.ea680771e910849fa12c78ea2cd533ef.svg";
export { ForwardRef as ReactComponent };